import { Component, OnInit } from '@angular/core';
import { User } from '../Master/user/user';
import { UseraddService } from '../Master/useradd/useradd.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RecentactivitiesdashboardService } from '../dashboard/recentactivitiesdashboard/recentactivitiesdashboard.service';

import { RequestconfigService } from '../configuration/requestconfig/requestconfig.service';
import { saveFile, saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalService } from '../local.service';
import {encryptdecrypt} from '../encryptdecrypt';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { environment } from '../../environments/environment';

declare var $: any;
import * as _ from 'lodash';
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {
  url: string = "src/assets/js/custom.js";
  //public userid = localStorage.getItem('userid');
  public userid = this.localService.getJsonValue('userid');
  //public username = localStorage.getItem('username');
  public username = this.localService.getJsonValue('username');
  public typeOfRole: string = '';     
  imagepath: any;
  user: User;
  acrnversion: string;
  docrecentactivitiesList: any = [];
  public requestDashboardMenuid: number = 30;
  viewMyRequestEnable: boolean = true;
  autologacess:number=-1;
  enc=new encryptdecrypt();
  public apitoken = this.localService.getJsonValue('apitoken');
  autologUrl:string=environment.autologUrl;
  isautologteam=+this.localService.getJsonValue('isautologteam');
  autologUserTeamId:number=environment.autologUserTeamId;
  constructor(private UseraddService: UseraddService, private _sanitizer: DomSanitizer,
    private recentactivitiesdashboardservice: RecentactivitiesdashboardService, 
    private requestConfigService: RequestconfigService, private toastr: ToastrService, 
    private SpinnerService: NgxSpinnerService, private localService: LocalService,
    private _router: Router,private route: ActivatedRoute
) { }

 
  ngOnInit() {
   
    this.UseraddService.GetById(+this.userid).subscribe(res => {

      if (res != undefined) {

        this.user = res.find(u => u.userid == +this.userid);

        //this.user = res;
        if (this.user.userrole === "Admin") {
          this.typeOfRole = "Admin";
        }
        console.log(this.user);
        this.autologacess=this.user.isautologuseronly;
        var allmenusMapped = JSON.parse(this.user.menumapped);
        var reqdashboardactionrights = allmenusMapped.find(e => e.menuid == this.requestDashboardMenuid)
        if (reqdashboardactionrights.action.length === 0)
          this.viewMyRequestEnable = false;
        else
          this.viewMyRequestEnable = true;

        if (this.user.profileimagepath != null) {

          this.UseraddService.GetImage(this.user.profileimagepath).subscribe(res => {

            if (res.type != 'text/plain') {

              let objectURL = 'data:image/jpeg;base64,' + res.image;

              this.imagepath = this._sanitizer.bypassSecurityTrustUrl(objectURL);

            }
          }, error => { });
        }
        else {

          this.imagepath = "../../assets/images/img.jpg";

        }
      }
    }, error => { });


    this.getDocumentRecentActivitiesList();

  }

  getDocumentRecentActivitiesList() {
    //let _userid: number;

    //_userid= +this.userid;
    let userData: string;
    userData = this.userid + '*' + 'getrecent*';
    this.recentactivitiesdashboardservice.getdocumentRecentActivities(userData,0,0).subscribe(res => {
       console.log(res);
      if (res != undefined && res != null && res.length != 0) {
        res.forEach((i, ind) => {
          var s = JSON.parse(i.sprecentactivitiesdocument);
          let _imgPath: any;
          if (s != undefined && s != null && s.length != 0) {
            if (s.imagepath != null) {
              this.UseraddService.GetImage(s.imagepath).subscribe(res => {
                if (res.type != 'text/plain') {
                  let objectURL = 'data:image/jpeg;base64,' + res.image;
                  _imgPath = this._sanitizer.bypassSecurityTrustUrl(objectURL);
                  this.docrecentactivitiesList.push({
                    formname: s.formconfigname,
                    firstname: s.firstname,
                    createdon: s.createdon,
                    imagepath: _imgPath,
                    documentid: s.documentid,
                    databaseid: s.databaseid,
                    formconfigid: s.formconfigid,
                    serialnumber: ind
                  });
                  this.docrecentactivitiesList = _.sortBy(this.docrecentactivitiesList, "serialnumber");
                }
              }, error => { });
            }
            else {
              _imgPath = "../../assets/images/img.jpg";
              this.docrecentactivitiesList.push(
                {
                  formname: s.formconfigname,
                  firstname: s.firstname,
                  createdon: s.createdon,
                  imagepath: _imgPath,
                  documentid: s.documentid,
                  databaseid: s.databaseid,
                  formconfigid: s.formconfigid,
                  serialnumber: ind
                });
              this.docrecentactivitiesList = _.sortBy(this.docrecentactivitiesList, "serialnumber");
            }
          }
        })
      }

    })
  }



  public loadScript() {
    //console.log("preparing to load...");
    let node = document.createElement("script");
    node.src = this.url;
    node.type = "text/javascript";
    node.async = true;
    node.charset = "utf-8";
    document.getElementsByTagName("head")[0].appendChild(node);
  }

  toggleclicked() {
    var $BODY = $('body'),
      $SIDEBAR_MENU = $('#sidebar-menu');
      
    //$(window).resize();
    //console.log('clicked - menu toggle');

    if ($BODY.hasClass('nav-md')) {
      $SIDEBAR_MENU.find('li.active ul').hide();
      $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active');
    } else {
      $SIDEBAR_MENU.find('li.active-sm ul').show();
      $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm');
    }

    $BODY.toggleClass('nav-md nav-sm');

    this.setContentHeight();

    $('.dataTable').each(function () { $(this).dataTable().fnDraw(); });
    return;
  }
  setContentHeight() {
    var $RIGHT_COL = $('.right_col'), $BODY = $('body'), $SIDEBAR_FOOTER = $('.sidebar-footer'),
      $LEFT_COL = $('.left_col'), $FOOTER = $('footer'), $NAV_MENU = $('.nav_menu');
  // reset height
  $RIGHT_COL.css('min-height', $(window).height());

  var bodyHeight = $BODY.outerHeight(),
    footerHeight = $BODY.hasClass('footer_fixed') ? -10 : $FOOTER.height(),
    leftColHeight = $LEFT_COL.eq(1).height() + $SIDEBAR_FOOTER.height(),
    contentHeight = bodyHeight < leftColHeight ? leftColHeight : bodyHeight;

  // normalize content
  contentHeight -= $NAV_MENU.height() + footerHeight;

  $RIGHT_COL.css('min-height', contentHeight);
  }
  basicinstructionDownload() {
    this.SpinnerService.show();
    let requestData: any = [];
    requestData.push({
      'requesttype': 'internetdownloadrequest', 'dbname': 'sampledocuments', 'requestid': null, 'fileName': 'ACRN_Basic_User_Instructions_v3.docx', 'type': null
    })

    this.requestConfigService.DownloadFileRequestWithSpecialCharacters(requestData[0]).subscribe(res => {
      var content = res.body.file;
      let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
      //saveAs(objectURL, 'sampletemplate.xlsx');
      saveAs(objectURL, 'ACRN_Basic_User_Instructions_v3.docx');
      this.SpinnerService.hide();
    },
      error => {
        this.toastr.error('File not found');
        this.SpinnerService.hide();
      });
  }

  showSelectedActivities(item){ 
    
    let queryParams = {};
    queryParams['formDB']  =this.enc.encryptUsingAES256(item.databaseid);
    queryParams['data']  =this.enc.encryptUsingAES256(item.documentid);
    queryParams['formConfigId']  =this.enc.encryptUsingAES256(item.formconfigid);
    queryParams['mode']  =this.enc.encryptUsingAES256('View');
  
    const navigationExtras: NavigationExtras = {
      queryParams,
      state: {  data: item.documentid ,
        formConfigId: item.formconfigid}
    }
    this._router.navigate(['/home/formrender'], navigationExtras);
  }


  openAutolog(){
    let openAutologUrl='';
    
    openAutologUrl=this.autologUrl+this.apitoken+'&auth=acrn';
  //  localStorage.clear();
    // Clear the localStorage
  //  this.localService.clearToken();
    window.open(openAutologUrl);
  }
}
